module.exports = __webpack_public_path__ + "static/media/ITC-TMI-2021-Comprehensive-Booklet.5f02a3c0.pdf";